import { BANNED_WORDS } from '../data/banned-words.js';
/**
 * The word filter (ADR 0037). A line of chat is masked word by word; a name
 * (nickname, guild, tag) is refused whole. Matching is by whole word after
 * normalisation, never by substring: « député » is not an insult.
 */
/** Digits and signs read as the letters they stand in for. */
const LEET = {
    '0': 'o',
    '1': 'i',
    '3': 'e',
    '4': 'a',
    '5': 's',
    '7': 't',
    '@': 'a',
    $: 's',
    '€': 'e',
};
/** Lower case, no accents, look-alike digits as letters, runs of a letter collapsed, letters only. */
export function normaliseWord(word) {
    const flat = word
        .normalize('NFD')
        .replace(/\p{M}/gu, '')
        .toLowerCase()
        .replace(/[0134579@$€]/g, (char) => LEET[char] ?? char)
        .replace(/[^\p{L}]/gu, '');
    return flat.replace(/(.)\1+/gu, '$1');
}
const BANNED = new Set(BANNED_WORDS.map(normaliseWord));
/** Whether one word of a text, plural or not, is on the list. */
function isBanned(word) {
    const key = normaliseWord(word);
    if (key.length === 0)
        return false;
    if (BANNED.has(key))
        return true;
    // A plural in -s or -x is the same word.
    return /[sx]$/.test(key) && BANNED.has(key.slice(0, -1));
}
/** Split on spaces and punctuation, keeping the separators so the text can be rebuilt. */
const TOKENS = /[\p{L}\p{N}@$€]+|[^\p{L}\p{N}@$€]+/gu;
export function containsBannedWord(text) {
    return (text.match(TOKENS) ?? []).some(isBanned);
}
/** The text with every banned word replaced by as many asterisks. */
export function maskBannedWords(text) {
    return (text.match(TOKENS) ?? [])
        .map((token) => (isBanned(token) ? '*'.repeat(token.length) : token))
        .join('');
}
//# sourceMappingURL=word-filter.js.map